
export const DARK_THEME_PRESETS = {
  dark_purple: {
    primary: "#A855F7",
    secondary: "#22D3EE",
    sidebarBgStart: "#0B0014",
    sidebarBgEnd: "#1B0033",
    active: "#A855F7",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#EF4444",
    genzGradientStart: "#A855F7",
    genzGradientMid: "#22D3EE",
    genzGradientEnd: "#F472B6",
    genzGlassFog: "rgba(31,41,55,0.6)",
  },

  dark_neo: {
    primary: "#22D3EE",
    secondary: "#F472B6",
    sidebarBgStart: "#020617",
    sidebarBgEnd: "#020617",
    active: "#22D3EE",
    hover: "rgba(255,255,255,0.14)",
    logoutHover: "#F87171",
    genzGradientStart: "#22D3EE",
    genzGradientMid: "#A855F7",
    genzGradientEnd: "#F472B6",
    genzGlassFog: "rgba(15,23,42,0.75)",
  },

  dark_ocean: {
    primary: "#0EA5E9",
    secondary: "#22D3EE",
    sidebarBgStart: "#020617",
    sidebarBgEnd: "#041B2D",
    active: "#0EA5E9",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#EF4444",
    genzGradientStart: "#0EA5E9",
    genzGradientMid: "#22D3EE",
    genzGradientEnd: "#38BDF8",
    genzGlassFog: "rgba(2,6,23,0.7)",
  },

  dark_forest: {
    primary: "#16A34A",
    secondary: "#22C55E",
    sidebarBgStart: "#022C22",
    sidebarBgEnd: "#064E3B",
    active: "#22C55E",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#16A34A",
    genzGradientMid: "#22C55E",
    genzGradientEnd: "#4ADE80",
    genzGlassFog: "rgba(6,78,59,0.7)",
  },

  dark_sunset: {
    primary: "#F97316",
    secondary: "#F43F5E",
    sidebarBgStart: "#2A0A0A",
    sidebarBgEnd: "#451A03",
    active: "#F97316",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#EF4444",
    genzGradientStart: "#F97316",
    genzGradientMid: "#FB7185",
    genzGradientEnd: "#F43F5E",
    genzGlassFog: "rgba(69,26,3,0.7)",
  },

  dark_steel: {
    primary: "#94A3B8",
    secondary: "#CBD5E1",
    sidebarBgStart: "#020617",
    sidebarBgEnd: "#0F172A",
    active: "#CBD5E1",
    hover: "rgba(255,255,255,0.1)",
    logoutHover: "#EF4444",
    genzGradientStart: "#94A3B8",
    genzGradientMid: "#CBD5E1",
    genzGradientEnd: "#E5E7EB",
    genzGlassFog: "rgba(15,23,42,0.8)",
  },

  dark_blue: {
    primary: "#2563EB",
    secondary: "#38BDF8",
    sidebarBgStart: "#020617",
    sidebarBgEnd: "#0B1C3D",
    active: "#2563EB",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#2563EB",
    genzGradientMid: "#38BDF8",
    genzGradientEnd: "#60A5FA",
    genzGlassFog: "rgba(2,6,23,0.75)",
  },
  dark_red: {
    primary: "#DC2626",
    secondary: "#F87171",
    sidebarBgStart: "#220000",
    sidebarBgEnd: "#3B0000",
    active: "#DC2626",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#EF4444",
    genzGradientStart: "#DC2626",
    genzGradientMid: "#F87171",
    genzGradientEnd: "#FB7185",
    genzGlassFog: "rgba(59,0,0,0.75)",
  },
  dark_orange: {
    primary: "#EA580C",
    secondary: "#FDBA74",
    sidebarBgStart: "#2A1204",
    sidebarBgEnd: "#431407",
    active: "#EA580C",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#EA580C",
    genzGradientMid: "#FDBA74",
    genzGradientEnd: "#FED7AA",
    genzGlassFog: "rgba(67,20,7,0.75)",
  },
  dark_teal: {
    primary: "#0D9488",
    secondary: "#5EEAD4",
    sidebarBgStart: "#022C2A",
    sidebarBgEnd: "#134E4A",
    active: "#0D9488",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#0D9488",
    genzGradientMid: "#5EEAD4",
    genzGradientEnd: "#99F6E4",
    genzGlassFog: "rgba(19,78,74,0.75)",
  },
  dark_indigo: {
    primary: "#4F46E5",
    secondary: "#A5B4FC",
    sidebarBgStart: "#0B0F2F",
    sidebarBgEnd: "#1E1B4B",
    active: "#4F46E5",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#4F46E5",
    genzGradientMid: "#A5B4FC",
    genzGradientEnd: "#C7D2FE",
    genzGlassFog: "rgba(30,27,75,0.75)",
  },
  dark_gray: {
    primary: "#6B7280",
    secondary: "#9CA3AF",
    sidebarBgStart: "#111827",
    sidebarBgEnd: "#1F2937",
    active: "#6B7280",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#6B7280",
    genzGradientMid: "#9CA3AF",
    genzGradientEnd: "#D1D5DB",
    genzGlassFog: "rgba(31,41,55,0.75)",
  },
dark_gold: {
    primary: "#FACC15",
    secondary: "#FDE047",
    sidebarBgStart: "#1C1917",
    sidebarBgEnd: "#292524",
    active: "#FACC15",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#FACC15",
    genzGradientMid: "#FDE047",
    genzGradientEnd: "#FEF08A",
    genzGlassFog: "rgba(28,25,23,0.75)"
  },

  dark_rose: {
    primary: "#E11D48",
    secondary: "#FB7185",
    sidebarBgStart: "#2A0A14",
    sidebarBgEnd: "#4C0519",
    active: "#E11D48",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#EF4444",
    genzGradientStart: "#E11D48",
    genzGradientMid: "#FB7185",
    genzGradientEnd: "#FDA4AF",
    genzGlassFog: "rgba(76,5,25,0.75)"
  },

  dark_cyan: {
    primary: "#06B6D4",
    secondary: "#67E8F9",
    sidebarBgStart: "#022B36",
    sidebarBgEnd: "#064E63",
    active: "#06B6D4",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#06B6D4",
    genzGradientMid: "#67E8F9",
    genzGradientEnd: "#A5F3FC",
    genzGlassFog: "rgba(6,78,99,0.75)"
  },

   dark_lime: {
    primary: "#84CC16",
    secondary: "#A3E635",
    sidebarBgStart: "#1A2E05",
    sidebarBgEnd: "#365314",
    active: "#84CC16",
    hover: "rgba(255,255,255,0.12)",
    logoutHover: "#DC2626",
    genzGradientStart: "#84CC16",
    genzGradientMid: "#A3E635",
    genzGradientEnd: "#BEF264",
    genzGlassFog: "rgba(54,83,20,0.75)"
  },

 dark_black: {
  primary: "#080808ff",
  secondary: "#ffffffff",
  sidebarBgStart: "#000000",
  sidebarBgEnd: "#000000",
  active: "#151414ff",
  hover: "rgba(255,255,255,0.14)",
  logoutHover: "#EF4444",
  genzGradientStart: "#000000",
  genzGradientMid: "#111111",
  genzGradientEnd: "#1A1A1A",
  genzGlassFog: "rgba(0,0,0,0.75)",
  headers: {
    primary: "#000000ff"
  },
}
};

export const DEFAULT_THEME_KEY = "dark_purple";

export const DEFAULT_PURPLE_PRESET = DARK_THEME_PRESETS.dark_purple;